import { gql } from "@apollo/client";

export const GET_ZATCA_INTEGRATION = gql`
  query GetZatcaIntegration {
    getZatcaIntegration {
      success
      message
      data {
        isConfigured
        lastSubmittedInvoiceHash
        invoiceCounterNumber
      }
    }
  }
`;

export const UPDATE_ZATCA_INTEGRATION = gql`
  mutation UpdateZatcaIntegration($input: UpdateZatcaIntegrationInput!) {
    updateZatcaIntegration(input: $input) {
      success
      message
      errors {
        field
        message
      }
    }
  }
`;
